module.exports = __webpack_public_path__ + "img/heart.c01d96a1.svg";